<template>
    <div class="bodyheight relative">
        <bg-global :bgLobby="bgLobby" />

        <div v-if="!gamesList.fetching" class="bodyheight flex flex-col gap-2 items-center justify-start p-2 overflow-auto z-10 relative">

            <jackpot class="mb-2" :jackpot="jackpot" />

            <div class="flex items-end justify-center gap-4">

                <h2 v-if="duels.length && gamesList.online" @click="selectTab('duels')" class="flex items-center border-2 border-outter-border border-b-0 rounded-tl-lg rounded-tr-lg translate-y-2">
                    <span class="bg-gradient-to-t from-black to-jackpot-bg font-semibold text-white text-sm px-4 py-1 uppercase gap-0 rounded-tl-lg rounded-tr-lg cursor-pointer">Duels</span>
                    <span v-if="duelsTotal > 0" class="bg-green-700 text-green-100 leading-4 rounded-md text-sm px-1 absolute -top-1 -right-1 font-mono">{{
                        duelsTotal }}</span>
                    <div v-if="gamesList.tab === 'duels'" class="border-2 border-black absolute -bottom-1 w-full" />
                </h2>

                <h2 v-if="sitAndGo.length && gamesList.online" @click="selectTab('sitAndGo')" class="flex items-center border-2 border-outter-border border-b-0 rounded-tl-lg rounded-tr-lg translate-y-2 relative">
                    <span class="bg-gradient-to-t from-black to-jackpot-bg font-semibold text-white text-sm px-4 py-1 uppercase gap-0 rounded-tl-lg rounded-tr-lg cursor-pointer">Sit&Go</span>
                    <span v-if="sitAndGoTotal > 0" class="bg-green-700 text-green-100 leading-4 rounded-md text-sm px-1 absolute -top-1 -right-1 font-mono">{{
                        sitAndGoTotal }}</span>
                    <div v-if="gamesList.tab === 'sitAndGo'" class="border-2 border-black absolute -bottom-1 w-full" />
                </h2>

                <h2 v-if="gamesList.online && ((specials.length) || isTeamWallet)" @click="selectTab('specials')" class="flex items-center border-2 border-outter-border border-b-0 rounded-tl-lg rounded-tr-lg translate-y-2 relative">
                    <span class="bg-gradient-to-t from-black to-jackpot-bg font-semibold text-white text-sm px-4 py-1 uppercase gap-0 rounded-tl-lg rounded-tr-lg cursor-pointer">Specials</span>
                    <span v-if="specialsTotal > 0" class="bg-green-700 text-green-100 leading-4 rounded-md text-sm px-1 absolute -top-1 -right-1 font-mono">{{
                        specialsTotal }}</span>
                    <div v-if="gamesList.tab === 'specials'" class="border-2 border-black absolute -bottom-1 w-full" />
                </h2>

            </div>

            <ul v-if="duels.length && gamesList.online && gamesList.tab === 'duels'" class="w-full flex flex-col gap-2 bg-transparent border-2 border-outter-border p-2 rounded-lg">
                <li @click="goToLobby(item)" v-for="item in duels" :key="'duels-' + item.id" class="bg-no-repeat bg-blend-multiply bg-cover flex flex-col gap-0 items-center border-2 py-1 px-2 select-none border-inner-border" :class="getColors()" :style="{ backgroundImage: `url(${getBgImage(item)})` }">
                    <div class="uppercase text-gray-100 font-semibold">{{ getGameName(item) }}</div>
                    <div class="flex flex-col w-full">
                        <div class="w-full flex items-center justify-between text-xs">
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Entry:</span>
                                <span v-if="ticketAvailable(item)" class="flex items-center gap-1">
                                    <span class="font-semibold text-sm">1x</span>
                                    <img :src="'/images/prize-' + item.slug + '.png'" class="block h-4 w-4" />
                                </span>
                                <span class="flex items-center gap-1" v-else>
                                    <span class="font-semibold text-sm">{{ entry(item) }}</span>
                                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                                    <span class="flex items-center gap-1">
                                        <span>+ {{ entryFee(item) }}</span>
                                        <img src="/images/sol.png" class="block h-3 w-3 rounded-full" />
                                    </span>
                                </span>
                            </div>
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Players:</span>
                                <span class="font-semibold text-sm">{{ getQueueSize(item) }}/{{ item.max_players
                                    }}</span>
                            </div>
                        </div>
                        <div class="w-full flex items-center justify-between text-xs">
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Prize:</span>
                                <span class="flex items-center gap-1">
                                    <span class="font-semibold text-sm">{{ entry(item) * item.max_players }}</span>
                                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                                </span>
                            </div>
                            <div class="flex items-center gap-1" v-if="rrTokenImage(item.token) !== null">
                                <span class="text-inner-border font-normal uppercase">Gem:</span>
                                <span class="flex items-center gap-1">
                                    <img :src="rrTokenImage(item.token)" class="block h-4 w-4 rounded-full" />
                                </span>
                                <span v-if="item.token_percentage > 0" class="text-xs font-mono">{{ item.token_percentage
                                    }}%</span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>

            <ul v-if="sitAndGo.length && gamesList.online && gamesList.tab === 'sitAndGo'" class="w-full flex flex-col gap-2 bg-transparent border-2 border-outter-border p-2 rounded-lg">
                <li @click="goToLobby(item)" v-for="item in sitAndGo" :key="'sitandgo-' + item.id" class="bg-no-repeat bg-blend-multiply bg-cover flex flex-col gap-0 items-center border-2 py-1 px-2 select-none border-inner-border" :class="getColors()" :style="{ backgroundImage: `url(${getBgImage(item)})` }">
                    <div class="uppercase text-gray-100 font-semibold">{{ getGameName(item) }}</div>
                    <div class="flex flex-col w-full">
                        <div class="w-full flex items-center justify-between text-xs">
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Entry:</span>
                                <span v-if="ticketAvailable(item)" class="flex items-center gap-1">
                                    <span class="font-semibold text-sm">1x</span>
                                    <img :src="'/images/prize-' + item.slug + '.png'" class="block h-4 w-4" />
                                </span>
                                <span class="flex items-center gap-1" v-else>
                                    <span class="font-semibold text-sm">{{ entry(item) }}</span>
                                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                                    <span class="flex items-center gap-1">
                                        <span>+ {{ entryFee(item) }}</span>
                                        <img src="/images/sol.png" class="block h-3 w-3 rounded-full" />
                                    </span>
                                </span>
                            </div>
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Players:</span>
                                <span class="font-semibold text-sm">{{ getQueueSize(item) }}/{{ item.max_players
                                    }}</span>
                            </div>
                        </div>
                        <div class="w-full flex items-center justify-between text-xs">
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Prize:</span>
                                <span class="flex items-center gap-1">
                                    <span class="font-semibold text-sm">{{ entry(item) * item.max_players }}</span>
                                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                                </span>
                            </div>
                            <div class="flex items-center gap-1" v-if="rrTokenImage(item.token) !== null">
                                <span class="text-inner-border font-normal uppercase">Gem:</span>
                                <span class="flex items-center gap-1">
                                    <img :src="rrTokenImage(item.token)" class="block h-4 w-4 rounded-full" />
                                </span>
                                <span v-if="item.token_percentage > 0" class="text-xs font-mono">{{ item.token_percentage
                                    }}%</span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>

            <ul v-if="((specials.length && gamesList.online) || isTeamWallet) && gamesList.tab === 'specials'" class="w-full flex flex-col gap-2 bg-transparent border-2 border-outter-border p-2 rounded-lg">
                <div v-if="isTeamWallet" class="bg-black/50 rounded p-4 flex flex-col border border-jackpot-bg">
                    <div class="text-center uppercase text-sm font-bold relative">
                        <span>Create Game</span>
                        <button @click.prevent="newGameToggle"
                            class="absolute right-0 top-0 bg-gray-800 text-white rounded-full flex items-center justify-center h-6 w-6">
                            <i v-if="showCreateGame" class="fas fa-times text-xs"></i>
                            <i v-else class="fas fa-plus text-xs"></i>
                        </button>
                    </div>
                    <div class="flex flex-col mt-4" v-if="showCreateGame">

                        <label class="text-white uppercase text-xs mb-4 flex inline-flex items-center gap-2">
                            Special Game?
                            <input v-model="newGame.is_special" type="checkbox">
                        </label>

                        <div class="flex flex-col items-start gap-1 mb-2">
                            <label class="text-xs text-gray-400 uppercase px-1">Name</label>
                            <input class="bg-white text-black p-1 rounded text-sm w-full outline-0" v-model.trim="newGame.name">
                            <div v-if="newGame.errors.name" class="px-1 text-xs text-red-500">{{ newGame.errors.name }}</div>
                        </div>

                        <div class="flex flex-col items-start gap-1" v-if="!newGame.is_special">
                            <label class="text-xs text-gray-400 uppercase px-1">Password</label>
                            <input class="bg-white text-black p-1 rounded text-sm w-full outline-0" v-model.trim="newGame.game_password">
                            <div v-if="newGame.errors.game_password" class="px-1 text-xs text-red-500">{{ newGame.errors.game_password }}</div>
                        </div>

                        <div v-if="newGame.is_special">
                            <div class="flex gap-2 items-start">
                                <div class="flex flex-col items-start gap-1 flex-1">
                                    <label class="text-xs text-gray-400 uppercase px-1">Min Players</label>
                                    <input v-model="newGame.min_players" type="numeric" class="block text-sm text-black w-full rounded p-1 outline-none focus-none" />
                                    <div v-if="newGame.errors.min_players" class="px-1 text-xs text-red-500">{{ newGame.errors.min_players }}</div>
                                </div>
                                <div class="flex flex-col items-start gap-1 flex-1">
                                    <label class="text-xs text-gray-400 uppercase px-1">Max Players</label>
                                    <input v-model="newGame.max_players" type="numeric" class="block text-sm text-black w-full rounded p-1 outline-none focus-none" />
                                    <div v-if="newGame.errors.max_players" class="px-1 text-xs text-red-500">{{ newGame.errors.max_players }}</div>
                                </div>
                            </div>
                        </div>

                        <label class="text-white uppercase text-xs mt-4 mb-2 flex inline-flex items-center gap-2" v-if="newGame.is_special">
                            Allow multiple entries?
                            <input v-model="newGame.multiple" type="checkbox">
                        </label>

                        <div class="flex items-start gap-2 mt-2">
                            <div class="flex flex-col items-start gap-1">
                                <label class="text-xs text-gray-400 uppercase px-1">Game Type</label>
                                <select v-model="newGame.type" class="text-black p-1 rounded text-sm outline-none focus-none">
                                    <option v-for="(name, slug) in availableGames" :key="'availableGames-' + slug" :value="slug">{{ name }}</option>
                                </select>
                                <div v-if="newGame.errors.type" class="px-1 text-xs text-red-500">{{ newGame.errors.type }}</div>
                            </div>
                            <div class="flex flex-col items-start gap-1 flex-1" v-if="newGame.is_special">
                                <label class="text-xs text-gray-400 uppercase px-1">Starts At</label>
                                <input v-model="newGame.starts_at" type="datetime-local" class="block text-sm text-black w-full rounded p-1 outline-none focus-none" placeholder="Starts At" />
                                <div v-if="newGame.errors.starts_at" class="px-1 text-xs text-red-500">{{ newGame.errors.starts_at }}</div>
                            </div>
                        </div>

                        <div class="flex justify-end mt-4">
                            <button :disabled="creating" class="modal-action-button" @click.prevent="createGame">Create Game</button>
                        </div>

                    </div>
                </div>
                <li @click="goToLobby(item)" v-for="item in specials" :key="'specials-' + item.id" class="bg-no-repeat bg-blend-multiply bg-cover flex flex-col gap-0 items-center border-2 py-1 px-2 select-none border-inner-border" :class="getColors()" :style="{ backgroundImage: `url(${getBgImage(item)})` }">
                    <div class="uppercase text-gray-100 font-semibold flex items-center justify-center gap-2 relative w-full">
                        <span v-if="getPadlock(item) && isTeamWallet && !item.is_special" class="absolute left-0 top-0 text-white flex items-center justify-center h-5 w-5 text-xs" @click.stop="copyInfo(item.id)"><i class="fa fa-lock"></i></span>
                        <span>{{ getGameName(item) }}</span>
                        <button
                            v-if="isTeamWallet"
                            @click.stop="deleteGame(item.id)"
                            class="absolute right-0 top-0 text-white flex items-center justify-center h-5 w-5">
                            <i class="fas fa-trash text-xs"></i>
                        </button>
                    </div>
                    <div class="flex flex-col w-full">
                        <div class="w-full flex items-center justify-between text-xs">
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Entry:</span>
                                <span v-if="!item.is_private && ticketAvailable(item)" class="flex items-center gap-1">
                                    <span class="font-semibold text-sm">1x</span>
                                    <img :src="'/images/prize-' + item.slug + '.png'" class="block h-4 w-4" />
                                </span>
                                <span class="flex items-center gap-1" v-else>
                                    <span class="font-semibold text-sm">{{ entry(item) }}</span>
                                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                                    <span class="flex items-center gap-1">
                                        <span>+ {{ entryFee(item) }}</span>
                                        <img src="/images/sol.png" class="block h-3 w-3 rounded-full" />
                                    </span>
                                </span>
                            </div>
                            <div class="flex items-center gap-1">
                                <span class="text-inner-border font-normal uppercase">Players:</span>
                                <span class="font-semibold text-sm">{{ getQueueSize(item) }}/{{ item.max_players }}</span>
                            </div>
                        </div>
                        <div class="w-full flex items-center justify-between text-xs">
                            <div class="flex items-center gap-1" v-if="!item.is_special">
                                <span class="text-inner-border font-normal uppercase">Prize:</span>
                                <span class="flex items-center gap-1">
                                    <span class="font-semibold text-sm">{{ entry(item) * item.max_players }}</span>
                                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                                </span>
                            </div>
                            <div class="flex items-center gap-1" v-else>
                                <span class="text-inner-border font-normal uppercase">Starts At:</span>
                                <span class="flex items-center gap-1">
                                    <span class="font-semibold text-sm">{{ toDate(item.starts_at) }}</span>
                                </span>
                            </div>
                            <div class="flex items-center gap-1" v-if="!item.is_private && rrTokenImage(item.token) !== null">
                                <span class="text-inner-border font-normal uppercase">Gem:</span>
                                <span class="flex items-center gap-1">
                                    <img :src="rrTokenImage(item.token)" class="block h-4 w-4 rounded-full" />
                                </span>
                                <span v-if="item.token_percentage > 0" class="text-xs font-mono">{{ item.token_percentage }}%</span>
                            </div>
                            <div class="flex items-center gap-1" v-if="item.is_special">
                                <span class="text-inner-border font-normal uppercase">Min Players:</span>
                                <span class="font-semibold text-sm">{{ item.min_players }}</span>
                            </div>
                        </div>
                    </div>
                </li>
                <li v-if="specials.length == 0" class="bg-no-repeat bg-blend-multiply bg-cover flex flex-col gap-0 items-center border-2 py-1 px-2 select-none border-inner-border">
                    No specials games found.
                </li>
            </ul>

            <h2 v-if="!gamesList.online" class="flex items-center border-2 border-outter-border border-b-0 rounded-tl-lg rounded-tr-lg translate-y-2">
                <span class="bg-gradient-to-t from-black to-jackpot-bg font-semibold text-white text-sm px-4 py-1 uppercase gap-0 rounded-tl-lg rounded-tr-lg">Queue Status</span>
            </h2>

            <ul class="w-full flex flex-col gap-2 bg-transparent border-2 border-outter-border p-2 rounded-lg" v-if="!gamesList.online">
                <li class="bg-no-repeat bg-blend-multiply bg-cover flex flex-col gap-2 items-center border-2 py-1 px-2 select-none border-inner-border">
                    <img src="/images/sprites/trait_danger.svg" class="w-24 block" />
                    <span class="font-semibold uppercase">The queue is Offline.</span>
                    <span class="mb-4 text-center">For more info, join our SBG Discord community <a class="text-inner-border underline" href="https://rumbleracers.com/discord" target="_blank">here</a>.</span>
                </li>
            </ul>

            <ul class="w-full flex flex-col gap-1 overflow-y-auto mt-4" v-if="debug.status">
                <li class="font-semibold text-center text-sm text-black dark:text-white">DEBUG <span v-if="subdomain">({{
                    subdomain }})</span></li>
                <li v-for="message in debug.messages" class="text-black dark:text-white text-xs">
                    {{ message }}
                </li>
            </ul>

        </div>

    </div>
</template>

<script>
import * as dayjs from 'dayjs'
import solana from '../mixins/solana'
import Jackpot from './Jackpot.vue'

export default {
    name: 'GamesList',
    components: { Jackpot },
    props: ['gamesList', 'token', 'connected', 'subdomain', 'debug', 'authenticated', 'jackpot', 'bgLobby', 'tokens', 'ticketsBalance', 'isTeamWallet'],
    mixins: [solana],
    data() {
        return {
            specialsFree: (process.env.MIX_SPECIALS_FREE === 'true'),
            game_fee: process.env.MIX_GAME_FEE,
            creating: false,
            showCreateGame: false,
            newGame: {
                name: '',
                game_password: '',
                type: 'brass-duel',
                starts_at: null,
                min_players: 2,
                max_players: 20,
                is_special: false,
                multiple: false,
                errors: {
                    name: '',
                    game_password: '',
                    type: '',
                    starts_at: '',
                    min_players: '',
                    max_players: '',
                }
            }
        }
    },
    computed: {
        duels() {
            return this.gamesList.list.filter((item) => {
                return item.type === 'duel'
            }).sort(function (a, b) {
                return a.show_order - b.show_order;
            })
        },
        specials() {
            return this.gamesList.private_list.sort(function (a, b) {
                return a.show_order - b.show_order;
            })
        },
        sitAndGo() {
            return this.gamesList.list.filter((item) => {
                return item.type === 'sit-and-go'
            }).sort(function (a, b) {
                return a.show_order - b.show_order;
            })
        },
        duelsTotal() {
            let total = 0
            this.duels.forEach((item) => {
                total = total + this.getQueueSize(item)
            })
            return total
        },
        sitAndGoTotal() {
            let total = 0
            this.sitAndGo.forEach((item) => {
                total = total + this.getQueueSize(item)
            })
            return total
        },
        specialsTotal() {
            let total = 0
            this.specials.forEach((item) => {
                total = total + this.getQueueSize(item)
            })
            return total
        },
        canQueue() {
            return this.authenticated && this.gamesList !== null && Object.keys(this.gamesList.queue).length > 0
        },
        availableGames() {
            return this.gamesList.list.reduce((acc, item) => {
                acc[item.slug] = item.name;
                return acc;
            }, {})
        }
    },
    methods: {
        toDate(date) {
            if (date === null) {
                return '-';
            }
            return dayjs(date).format('YYYY-MM-DD HH:mm')
        },
        generateRandomString(length) {
            let result = '';
            const characters = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        async copyInfo(id) {
            try {
                let info = null
                await axios.post('/api/admin/specials/info', { id }, {
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    }
                }).then((response) => {
                    info = response.data.info
                })
                if (info === null) {
                    throw new Error('Error getting info.');
                }
                await this.copyToClipboard(info)
                this.$toast.success('Copied to clipboard!')
            } catch (err) {
                console.log(err)
                this.$toast.error('Failed to copy to clipboard!')
            }
        },
        newGameToggle() {
            this.showCreateGame = !this.showCreateGame
            if (this.showCreateGame) {
                this.newGame.game_password = this.generateRandomString(10)
            }
        },
        resetGameErrors() {
            this.newGame.errors.name = ''
            this.newGame.errors.game_password = ''
            this.newGame.errors.type = ''
            this.newGame.errors.starts_at = ''
            this.newGame.errors.min_players = ''
            this.newGame.errors.max_players = ''
        },
        resetGameForm() {
            this.newGame.name = ''
            this.newGame.game_password = ''
            this.newGame.type = 'brass-duel'
            this.newGame.starts_at = null
            this.newGame.min_players = 2
            this.newGame.max_players = 20
            this.newGame.is_special = false
            this.newGame.multiple = false
        },
        createGame() {
            this.creating = true
            this.resetGameErrors()
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
            const data = {
                name: this.newGame.name,
                game_password: this.newGame.game_password,
                type: this.newGame.type,
                is_special: this.newGame.is_special,
                starts_at: this.newGame.starts_at,
                tz: tz,
                min_players: this.newGame.min_players,
                max_players: this.newGame.max_players,
                multiple: this.newGame.multiple
            }
            if (!this.newGame.is_special) {
                data.min_players = null
                data.max_players = null
                data.multiple = false
            }
            axios.post('/api/admin/specials/create', data, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.$toast.success(response.data.message)
                this.resetGameErrors()
                this.resetGameForm()
                this.showCreateGame = false
            }).catch((err) => {
                if (err?.response?.data?.errors) {
                    for (const key in err.response.data.errors) {
                        if (err.response.data.errors.hasOwnProperty(key)) {
                            this.newGame.errors[key] = err.response.data.errors[key][0]
                        }
                    }
                }
                this.$toast.error('Error adding Game.')
            }).finally(() => {
                this.creating = false
            })
        },
        async deleteGame(id) {
            await axios.post('/api/admin/specials/delete', { id }, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.$toast.success(response.data.message)
            }).catch((err) => {
                this.$toast.error('Error deleting Game.')
            })
        },
        selectTab(tab) {
            if (tab !== this.gamesList.tab) {
                this.$emit('selected-tab', tab)
            }
        },
        ticketAvailable(item) {
            return this.ticketsBalance[item.slug]
        },
        entry(item) {
            if (this.specialsFree && item.is_special) {
                return 0
            }
            return this.lamportsToSol(item.entry)
        },
        entryFee(item) {
            if (this.specialsFree && item.is_special) {
                return 0
            }
            return this.lamportsToSol(item.entry * this.game_fee)
        },
        getQueueSize(item) {
            if (item.is_private) {
                return this.gamesList?.private_queue[item.id]?.length ?? 0
            }
            return this.gamesList?.queue[item.id]?.length ?? 0
        },
        getBgImage(item) {
            return '/images/games/bg-' + item.slug + '.jpg'
        },
        getColors() {
            const disabled = this.canQueue ? 'bg-gray-500 text-white' : 'bg-gray-800 text-gray-600';
            return disabled
        },
        getPadlock(item) {
            return item.is_private === true
        },
        getGameName(item) {
            return item.name
        },
        goToLobby(item) {
            if (!this.authenticated) {
                return
            }
            this.emitter.emit('go-to-game-lobby', item)
        },
        rrTokenImage(token) {
            const found = this.tokens.find(item => item.slug === token)
            if (found === undefined) {
                return null
            }
            return found.image
        }
    }
}
</script>
